module.exports = __webpack_public_path__ + "img/Group 26978@2x.1b643c76.png";